// import LeftIndent01Icon from '@untitled-ui/icons-react/build/esm/LeftIndent01';
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease'
// import RightIndent01Icon from '@untitled-ui/icons-react/build/esm/RightIndent01';
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease'
import { Chip, Stack, SvgIcon, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const options = [
    {
        label: 'Left-to-right',
        value: 'ltr',
        icon: (
            <SvgIcon fontSize="small">
                <FormatIndentIncreaseIcon />
            </SvgIcon>
        )
    },
    {
        label: 'Right-to-left',
        value: 'rtl',
        icon: (
            <SvgIcon fontSize="small">
                <FormatIndentDecreaseIcon />
            </SvgIcon>
        )
    }
]

export const OptionsDirection = (props) => {
    const { onChange, value } = props

    return (
        <Stack spacing={1}>
            <Typography
                color="text.secondary"
                variant="overline"
                sx={{ mt: 4 }}
            >
                Orientation
            </Typography>
            <Stack alignItems="center" direction="row" flexWrap="wrap" gap={2}>
                {options.map((option) => (
                    <Chip
                        icon={option.icon}
                        key={option.label}
                        label={option.label}
                        onClick={() => onChange?.(option.value)}
                        sx={[
                            {
                                borderColor: 'transparent',
                                borderStyle: 'solid',
                                borderWidth: 2
                            },
                            option.value === value && {
                                borderColor: 'primary.main'
                            }
                        ]}
                    />
                ))}
            </Stack>
        </Stack>
    )
}

OptionsDirection.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.oneOf(['ltr', 'rtl'])
}
